export default {
  generic: {
    productCode: '产品编码',
    productDetail: '产品详情',
    pixel: '像素',
    productSize: '产品尺码',
    size: '尺码',
    chName: '中文名称',
    enName: '英文名称',
    productionTechnolegy: '生产工艺',
    productMaterial: '产品材质',
    material: '材质',
    viewMore: '查看更多',
    more: '更多',
    exit: '退出',
    workbench: '工作台',
    myGallery: '我的图库',
    goodsLibrary: '选品库',
    productLibrary: '产品库',
    orderAdmin: '订单管理',
    cart: '购物车', // 购物车
    accountInformation: '账户信息',
    warning: '温馨提示',
    yes: '确定',
    cancel: '取消',
    deleteConfirm: '您是否确定删除?',
    search: '搜索',
    reset: '重置',
    color: '颜色',
    copy: '复制',
    hide: '隐藏',
    delete: '删除',
    addToCart: '添加到购物车',
    enterContent: '请输入内容',
    all: '所有',
    unpaid: '待付款',
    needApproval: '待审核',
    inProduction: '生产中',
    shipped: '已发货',
    store: '店铺',
    orderID: '订单ID',
    address: '地址',
    total: '总计',
    products: '产品',
    quantity: '数量',
    item: '项',
    edit: '编辑',
    reorder: '复制订单'
  },
  homepage: {
    allProducts: '所有产品',
    bestSeller: '畅销产品',
    newArraivals: '新到产品',
    premiumProducts: '优质产品',
    economicalProducts: '实惠产品'
  },
  main: {
    welcome: '欢迎',
    storeSetupChecklist: '商店设置清单',
    stepsCompleted: '步骤已完成',
    step1: '创建Printify帐户',
    step2: '设计您的第一个产品',
    step3: '订购样品',
    step4: '连接您的商店并开始销售',
    step5: '向您的商店发布1个产品',
    trendingProducts: '热门产品',
    tips: '教程文档',
    seeMore: '查看更多',
    mainMenu: '主菜单',
    order: '订单',
    designs: '设计',
    stores: '店铺',
    billing: '账单',
    affiliateProgram: '联盟计划',
    homepage: '首页',
    product: '选品',
    coupon: '优惠券'
  },
  login: {
    forgetMessage:
      "Enter your email, and we'll send you a password reset link. This may take a few minutes! If you don't received the email, please check your spam. E-mail", // 忘记密码标题提示
    fullname: '用户名',
    email: '邮箱',
    password: '密码',
    passwordConfirm: '确认密码',
    verificationCode: '验证码',

    fullnameRule: '请输入用户名',
    emailRule: '请输入正确的邮箱地址',
    passwordRule: '请输入密码',
    passwordConfirmRule: '请输入确认密码',
    verificationCodeRule: '请输入验证码',
    login: '登录',
    register: '注册',
    forget: '忘记密码',
    send: '获取验证码',
    vCode_modal: {
      title: 'Verify Your Email',
      content_before:
        'There is the last step to complete registration. For account security, please enter the verification code in ',
      content_after: "we sent to you. If you don't see it, please check your spam folder."
    }
  },
  design: {
    saveProduct: '保存产品',
    revoke: '撤销',
    recovery: '恢复',
    clear: '清空',
    productHover: '点击商品名称可查看商品详情和切换产品颜色',
    fullScreen: '全屏',
    shortcutKey: '快捷键',
    designRecord: '设计记录',
    recentlyDesignedProducts: '最近设计的产品',
    generalOperation: '常规操作',
    hotkeysPlaceholder: '请按键盘进行设詈',
    restoreInitialKey: '恢复初始按键',
    customizeShortcutKeys: '自定义快捷键',
    cancelSetting: '取消设置',
    saveSetting: '保存设置',
    restoreKeyWarning: '您确定恢复默认快捷键吗？',
    saveShortcutKeys_before: '快捷键与“保存(',
    saveShortcutKeys_after: ')”存在冲突，请重新设置',
    copySuccessful: '复制成功',
    notAllowCopy: '该浏览器不支持自动复制',
    customColors: '自定义颜色',
    customColorsTips: '最多添加30个自定义颜色；右击颜色可删除',
    product: '产品',
    gallery: '图库',
    text: '文字',
    background: '背景',
    layer: '图层',
    designOrNot: '是否设计',
    designed: '已设计',
    notDesigned: '未设计',
    pictureShape: '图片形状',
    quasiSquare: '似方形',
    transverseShape: '横向形',
    verticalShape: '竖向形',
    superTransverseShape: '超横形',
    superVerticalShape: '超竖形',
    pictureLabel: '图片标签',
    tort: '侵权',
    uploadPicture: '上传图片',
    allProducts: '全部商品',
    myProducts: '我的商品',
    shareGallery: '共享图库',
    addText: '+添加文字',
    enterText: '输入文字',
    fontColor: '字体颜色',
    addToCustomColor: '添加到自定义颜色',
    takeColor: '取色',
    presetColor: '预设颜色',
    notSupportColor: '此产品不支持设置背景颜色',
    promotion: '促',
    addCartSuccess: '加购成功',
    viewNow: '立即查看',
    addCartRule: '至少有一项数量不为0!',
    viewRenderings: '查看效果图',
    colorFinder: '取色器',
    copyFace: '复制面',
    copyToAllFaces: '复制至全部面',
    copyToFace: '复制至面',
    heightFill: '高度填充',
    widthFill: '宽度填充',
    fill: '填充',
    adapt: '适应',
    center: '居中',
    flipHorizontally: '水平翻转',
    flipVertically: '垂直翻转',
    rotate: '旋转',
    cutHead: '抠头',
    cutPicture: '抠图',
    clearly: '清晰',
    crop: '裁剪',
    image: '图像',
    xSpacing: 'X轴间距',
    ySpacing: 'Y轴间距',
    tile: '平铺',
    style: '风格',
    shade: '遮罩',
    moveLayerUp: '图层上移',
    moveLayerDown: '图层下移',
    deleteLayer: '删除图层',
    editElementTips: '请选择元素进行编辑'
  },
  order: {
    orders: '订单',
    synOrder: '同步订单',
    cancelOrder: '取消订单',
    CSVOrderImport: ' csv订单导入',
    orderInputpPlaceholder: '请输入订单ID或产品名称',
    batchesExportOrderInvoice: '批量导出发票',
    batchesExportOrderInvoiceContent: '你确定批量导出发票',
    invoice: '导出发票',
    invoiceContent: '你确定导出发票',
    uploadLabels: '批量上传面单按钮',
    modifyLogisticsInBatches: '批量修改物流'
  },
  orderImport: {
    uploadOrderImport: '订单导入',
    importOderWithDesignTemplate: '在设计模板中导入带有设计的订单',
    uploadFile: '上传文件',
    related: '相关的',
    addFiles: '添加文件',
    fileFormatRule: '只允许.csv文件',
    fileSizeRule: '小于1MB',
    sampleOrderTemplate: '简单订单模板',
    alpha2CountryCode: 'Alpha-2国家代码',
    introductUseCSV: '介绍如何使用CSV文件导入带有设计模板中的设计的订单'
  },
  payment: {
    checkout: '结算',
    purchase: '购买'
  },
  orderEdit: {
    orderDetials: '订单详情',
    printdoorsOrder: 'printdoors订单',
    orderStatus: '订单状态',
    orderTime: '订单时间',
    orderCreated: '创建订单',
    orderTimeline: '订单时间线',
    orderInformation: '订单信息',
    paymentMethod: '付款方式',
    subtotal: '小计',
    coupon: '优惠券',
    shipping: '物流',
    tax: '税',
    printdoorsDesign: 'printdoors设计',
    original: '原产品',
    cancelOrderTitle: '取消订单',
    cancelOrderContent: ' 您确认要取消订单吗？',
    orderEidt: '编辑订单',
    continue: '继续',
    operation: '操作'
  },
  customer: {
    customer: '客户',
    name: '客户',
    company: '公司',
    address: '地址',
    telephone: '电话'
  },
  billing: {
    billingTitle: '账单付款',
    billingReport: '导出文件'
  },
  productTemplate: {
    template: '模板'
  }
}
